/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 */

// Critical: Define process and global IMMEDIATELY before any imports
(globalThis as any).process = (globalThis as any).process || {
  env: { NODE_ENV: 'production' },
  version: '',
  versions: { node: '18.0.0' },
  platform: 'browser',
  argv: [],
  cwd: () => '/',
  nextTick: (fn: (...args: unknown[]) => unknown) => setTimeout(fn, 0),
  browser: true,
  title: 'browser',
};

(globalThis as any).global = globalThis;
(window as any).global = window;
(window as any).process = (globalThis as any).process;

// Node.js polyfills for browser environment
import { Buffer } from 'buffer';
import * as CryptoJS from 'crypto-js';
import { v4 as uuidv4 } from 'uuid';

// Merge process from the process package with our minimal process
const processPolyfill = Object.assign((globalThis as any).process || {}, {
  env: { NODE_ENV: 'production' },
  version: '',
  versions: { node: '18.0.0' },
  platform: 'browser',
  argv: [],
  cwd: () => '/',
  nextTick: (fn: (...args: unknown[]) => unknown) => setTimeout(fn, 0),
  browser: true,
  title: 'browser',
});

// Immediately assign process and Buffer to global scope before anything else
(globalThis as any).process = processPolyfill;
(globalThis as any).Buffer = Buffer;
(globalThis as any).global = globalThis;

// Also assign to window for compatibility
if (typeof window !== 'undefined') {
  (window as any).process = processPolyfill;
  (window as any).Buffer = Buffer;
  (window as any).global = window;
}

// Ensure require function is available for Azure SDK and other libraries
if (typeof (window as any).require === 'undefined') {
  (window as any).require = function (name: string) {
    console.log('Polyfill require called for:', name);
    switch (name) {
      case 'buffer':
        return { Buffer };
      case 'process':
        return processPolyfill;
      case 'crypto':
        console.log('Returning crypto-js wrapper:', CryptoJS);
        // Return a Node.js crypto compatible API using crypto-js
        return {
          createHmac: function (algorithm: string, key: string | Buffer) {
            return {
              update: function (data: string, _encoding?: string) {
                return {
                  digest: function (outputEncoding: string) {
                    // Convert Buffer to WordArray if needed
                    const keyWordArray =
                      typeof key === 'string'
                        ? CryptoJS.enc.Utf8.parse(key)
                        : CryptoJS.lib.WordArray.create(new Uint8Array(key));

                    const dataWordArray = CryptoJS.enc.Utf8.parse(data);

                    if (algorithm === 'sha256') {
                      const hash = CryptoJS.HmacSHA256(dataWordArray, keyWordArray);
                      return outputEncoding === 'base64' ? CryptoJS.enc.Base64.stringify(hash) : hash.toString();
                    }
                    throw new Error(`Unsupported algorithm: ${algorithm}`);
                  },
                };
              },
            };
          },
          createHash: function (algorithm: string) {
            return {
              update: function (data: string, _encoding?: string) {
                return {
                  digest: function (outputEncoding: string) {
                    const dataWordArray = CryptoJS.enc.Utf8.parse(data);
                    if (algorithm === 'sha256') {
                      const hash = CryptoJS.SHA256(dataWordArray);
                      return outputEncoding === 'base64' ? CryptoJS.enc.Base64.stringify(hash) : hash.toString();
                    }
                    throw new Error(`Unsupported algorithm: ${algorithm}`);
                  },
                };
              },
            };
          },
        };
      case 'uuid':
        return { v4: uuidv4 };
      case 'util':
        // Basic util polyfill for browser
        return {
          inherits: function (ctor: any, superCtor: any) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
              constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true,
              },
            });
          },
          inspect: function (obj: any) {
            return JSON.stringify(obj);
          },
          deprecate: function (fn: (...args: unknown[]) => unknown, _msg: string) {
            return fn;
          },
        };
      default:
        throw new Error(`Cannot resolve module '${name}'`);
    }
  };
}

// Additional debug logging
console.log('Polyfills loaded - process:', typeof (window as any).process);
console.log('Polyfills loaded - Buffer:', typeof (window as any).Buffer);
console.log('Polyfills loaded - crypto:', crypto);
